import Training from './training'

export default Training
